import { FC } from "react";
import { Box } from "@radix-ui/themes";

interface CircularProgressProps {
  activeIndex: number;
  totalSlides: number;
  progress: number;
}

export const CircularProgress: FC<CircularProgressProps> = ({
  activeIndex,
  totalSlides,
  progress,
}) => {
  return (
    <Box position="absolute" top="4" right="4" style={{ zIndex: 1002 }}>
      <svg width="24" height="24" viewBox="0 0 36 36">
        {/* Background circle */}
        <circle
          cx="18"
          cy="18"
          r="16"
          fill="none"
          stroke="rgba(255, 255, 255, 0.3)"
          strokeWidth="3"
        />

        {/* Progress circle */}
        <circle
          cx="18"
          cy="18"
          r="16"
          fill="none"
          stroke="white"
          strokeWidth="3"
          strokeDasharray={`${2 * Math.PI * 16}`}
          strokeDashoffset={`${2 * Math.PI * 16 * (1 - progress / 100)}`}
          transform="rotate(-90 18 18)"
          style={{
            transition: "stroke-dashoffset 0.1s linear",
          }}
        />
      </svg>
    </Box>
  );
};
